import { useState } from "react";

/** Whether `src` names something to load: not missing, empty or blank. */
export function hasImageSource(src: string | null | undefined): src is string {
  return typeof src === "string" && src.trim() !== "";
}

/**
 * Whether an image can't be drawn, and the `onError` that says so: its source is missing or
 * blank, or it failed to load. The failure belongs to that source, so a new `src` tries again.
 * Every component that draws a remote image takes it, and draws a stand-in or nothing when it is
 * `failed` (`ArtPlaceholder`, `OptionalImage`); `meta/imageFallback.test.ts` holds them to it.
 */
export function useImageFallback(src: string | null | undefined): {
  failed: boolean;
  onError: () => void;
} {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  return {
    failed: !hasImageSource(src) || failedSrc === src,
    onError: () => setFailedSrc(src ?? null),
  };
}
